import PropTypes from 'prop-types';
import { useRef } from 'react';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import classes from './SectionLayout.module.css';
import SectionView from '../../SectionView/SectionView';

const SectionLayout = ({ currentSection, section }) => {
  const headerRef = useRef();
  const { name, color } = currentSection;
  const backToTopHandler = () => {
    if (headerRef.current)
      headerRef.current.scrollIntoView({ inline: 'start' });
  };
  return (
    <div ref={headerRef} className={classes.sectionLayout}>
      <span style={{ backgroundColor: color }}>
        <Header backgroundColor={color} name={name} />
        <div
          className={classes.contentContainer}
          style={{ backgroundColor: 'white', minHeight: '100%' }}
        >
          <SectionView onBackToTop={backToTopHandler} section={section} />
        </div>
      </span>
      <Footer onBackToTop={backToTopHandler} />
    </div>
  );
};

SectionLayout.propTypes = {
  currentSection: PropTypes.shape({
    name: PropTypes.string,
    color: PropTypes.string,
    imagePreview: PropTypes.string,
  }).isRequired,
  section: PropTypes.shape({
    viewType: PropTypes.oneOf(['GENERAL', 'WITH_SUBSECTIONS']),
    subsections: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    color: PropTypes.string.isRequired,
  }).isRequired,
};

export default SectionLayout;
